import { render } from "./DeliveryDispatch.vue?vue&type=template&id=d2c4cb7e&scoped=true"
import script from "./DeliveryDispatch.vue?vue&type=script&lang=js"
export * from "./DeliveryDispatch.vue?vue&type=script&lang=js"

import "./DeliveryDispatch.vue?vue&type=style&index=0&id=d2c4cb7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2c4cb7e"]])

export default __exports__